import React from "react";

function RegistrationSuccess() {
	return <h5>Registration Successful.</h5>;
}

export default RegistrationSuccess;
